import { connect } from 'react-redux';

const mapStateToProps = ({ QualificationsData }) => ({ QualificationsData });

export default (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);
